import { FaceNavTrigger } from './components/FaceNavTrigger';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { useState } from 'react';
import { FaceNavHeader } from './components/FaceNavHeader';
import { useSelector } from 'react-redux';
// @ts-expect-error js file is not typed
import { getUser } from '../../selectors/userSelectors';
import formatName from 'I18n/utils/formatName';
import { FaceNavPortalPicker } from './components/FaceNavPortalPicker';
import { FaceNavInviteYourTeam } from './components/FaceNavInviteYourTeam';
import { FaceNavAccountLinks } from './components/FaceNavAccountLinks';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { useHomepageUrl } from '../../features/navigation';
import { FaceNavFooter } from './components/FaceNavFooter';
import { View } from 'foundations-components/components/View';
import { FACE_NAV_WIDTH } from './constants/FACE_NAV_WIDH';
import I18n from 'I18n';
import { useAvatarUrl } from './hooks/useAvatarUrl';
import { useHasScope } from '../../features/accounts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FaceNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const portalId = PortalIdParser.getPortalIdFromPath();
  const baseAppUrl = getFullUrl('app');
  const user = useSelector(getUser);
  const {
    avatarUrl
  } = useAvatarUrl();
  const {
    homepage
  } = useHomepageUrl();
  const userPreferencesUrl = `${baseAppUrl}/user-preferences/${portalId || ''}`;
  const formattedName = user ? formatName({
    firstName: user.firstName || '',
    lastName: user.lastName || ''
  }) : '';
  const {
    hasScope: usersWriteScopeIncluded
  } = useHasScope('users-write');
  const {
    hasScope: userWithAcademyStudio
  } = useHasScope('academy-studio-content-management');
  const {
    hasScope: userWithProjectAccess
  } = useHasScope('projects-access');
  let academyStudioUrl = undefined;
  if (userWithAcademyStudio) {
    academyStudioUrl = `${baseAppUrl}/academy-studio/${portalId}`;
    const isLocal = /^local/.test(document.location.hostname);
    academyStudioUrl = `${getFullUrl(isLocal ? 'local' : 'app')}/academy-studio/${portalId}`;
  }
  return /*#__PURE__*/_jsx(Popover, {
    arrowSize: 'small',
    autoPlacement: false,
    closeOnOutsideClick: true,
    content: /*#__PURE__*/_jsxs(View, {
      "aria-label": I18n.text('learningCenter.faceNav.accessibility.account_menu'),
      maxInlineSize: FACE_NAV_WIDTH,
      minInlineSize: FACE_NAV_WIDTH,
      role: "menu",
      children: [/*#__PURE__*/_jsx(FaceNavHeader, {
        avatarUrl: avatarUrl,
        name: formattedName,
        userEmail: user === null || user === void 0 ? void 0 : user.email,
        userPreferencesUrl: userPreferencesUrl
      }), /*#__PURE__*/_jsx(FaceNavPortalPicker, {}), usersWriteScopeIncluded && /*#__PURE__*/_jsx(FaceNavInviteYourTeam, {
        portalId: portalId
      }), /*#__PURE__*/_jsx(FaceNavAccountLinks, {
        academyStudioUrl: academyStudioUrl,
        baseAppUrl: baseAppUrl,
        hasProjectAccess: userWithProjectAccess,
        homepageUrl: homepage,
        portalId: portalId
      }), /*#__PURE__*/_jsx(FaceNavFooter, {})]
    }),
    marginBlockStart: "200",
    onOpenChange: e => setIsOpen(e.currentTarget.value),
    open: isOpen,
    placement: "bottom left",
    children: /*#__PURE__*/_jsx(FaceNavTrigger, {
      avatarUrl: avatarUrl,
      isOpen: isOpen,
      name: formattedName,
      onClick: () => setIsOpen(prev => !prev)
    })
  });
};